import styled from 'styled-components';

export const TableWrapper = styled.div`
	max-height: 600px;
	overflow: hidden;
	overflow-y: scroll;
`;
